import { render, staticRenderFns } from "./entertainment.vue?vue&type=template&id=3796d63a"
import script from "./entertainment.vue?vue&type=script&lang=js"
export * from "./entertainment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports